<template>
  <div class="section-mian_left videoTree">
    <!-- 头部 -->
    <div class="video-tab">
      <div
        v-for="item in constList.tabs"
        :key="item.typeId"
        :class="['tab', activeTab == item.typeId ? 'active' : '']"
        @click="handleTab(item)"
      >
        {{ item.label }}
      </div>
    </div>
    <!--内容-->
    <div :class="[showTime && 'show-time', 'video-content']">
      <!-- 监控点 -->
      <device-group-tree
        v-show="activeTab == 1"
        ref="deviceTree"
        :multiCheck="true"
        :showPercentage="true"
        :isCollection="true"
        @handleCollectUpdate="handleCollectUpdate"
      >
      </device-group-tree>
      <!-- 收藏夹 -->
      <video-collect
        v-show="activeTab == 2"
        ref="deviceCollect"
        :multiCheck="true"
      ></video-collect>

      <!-- 录像时间收索  云台控制-->
      <div class="video-time">
        <div class="date-title" @click="showPtz = !showPtz">
          <div>云台控制</div>
          <i :class="showPtz ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"> </i>
        </div>
        <video-ptz v-show="showPtz" />
        <div class="date-title" @click="showTime = !showTime">
          <div>录像查询</div>
          <i :class="showTime ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"> </i>
        </div>
        <div class="date-content" v-show="showTime">
          <el-form
            :model="searchForm"
            :rules="constList.rules"
            ref="searchForm"
            label-width="60px"
            label-position="top"
          >
            <el-form-item label="时间范围" prop="date">
              <el-date-picker
                style="width: 100%"
                v-model="searchForm.date"
                type="datetimerange"
                range-separator="~"
                :default-time="['00:00:00', '23:59:59']"
                :picker-options="pickerOptions"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
          <div style="text-align: center">
            <el-button
              type="primary"
              size="small"
              :loading="searchLoading"
              @click="handleSearchVideos"
            >
              {{ !searchLoading ? "查询" : "查询中..." }}
            </el-button>
            <el-button size="small" @click="handleReset" type="info"> 重置 </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import deviceGroupTree from "./device-group-tree";
import videoCollect from "./video-collect";
import videoPtz from "./video-ptz";
import busVue from "@/common/utils/busVue";
export default {
  components: { deviceGroupTree, videoCollect, videoPtz },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() >= Date.now();
        },
      },
      constList: {
        tabs: [
          {
            label: "监控点",
            typeId: "1",
          },
          {
            label: "收藏夹",
            typeId: "2",
          },
          // {
          //   label: "云台控制",
          //   typeId: "3",
          // },
        ],
        videoType: [
          { label: "设备组", value: 0 },
          { label: "区域树", value: 1 },
        ],
        rules: {
          date: [
            {
              required: true,
              message: "请选择时间范围",
              trigger: ["blur", "change"],
            },
          ],
        },
      },
      searchLoading: false,
      searchForm: {
        date: [],
      },
      activeTab: 1,
      showTime: false,
      showPtz: false,
    };
  },
  mounted() {
     this.searchForm.date= [this.dataConvert().substr(0, 11) + '00:00:00',this.dataConvert()];
  },
  methods: {
    dataConvert(val) {
      let date1 = new Date();
      let year = date1.getFullYear();
      let month = date1.getMonth() + 1;
      let date = '';
      if (val) {
        date1.setDate(date1.getDate() + val);
        date = date1.getDate();
      } else {
        date = date1.getDate();
      }
      let hour = date1.getHours();
      year = date1.getFullYear();
      month = date1.getMonth() + 1;
      let minutes = date1.getMinutes();
      let second = date1.getSeconds();
      if (month < 10) {
        month = '0' + month;
      }
      if (date < 10) {
        date = '0' + date;
      }
      if (hour < 10) {
        hour = '0' + hour;
      }
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      if (second < 10) {
        second = '0' + second;
      }
      return (
        year +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        second
      );
    },
    handleCollectUpdate() {
      this.$refs.deviceCollect.queryFileList();
    },
    handleTab(item) {
      this.activeTab = item.typeId;
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
    },
    //录像查询-时间范围
    handleSearchVideos() {
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          let checkedDevice = this.$refs[
            this.activeTab == 1 ? "deviceTree" : "deviceCollect"
          ].checkedDevice;
          if (!checkedDevice.length) {
            this.$message.warning("请选择摄像机设备");
            return;
          }
          this.searchLoading = true;
          checkedDevice.forEach((item) => {
            let obj = {
              id: item.id,
              startTime: this.searchForm.date[0],
              endTime: this.searchForm.date[1],
              thirdCameraId: item.thirdCameraId,
              name: item.name,
            };
            setTimeout(() => {
              busVue.$emit("handleChooseCameraVideo", obj);
            }, 50);
          });
          this.$nextTick(() => {
            this.searchLoading = false;
            this.$refs[
              this.activeTab == 1 ? "deviceTree" : "deviceCollect"
            ].resetSelect();
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
:deep .el-date-editor .el-range-input {
  width: 45% !important;
}
.videoTree {
  width: 342px;
  height: 100%;
  padding: 16px;
  position: relative;

  .video-tab {
    display: flex;
    .tab {
      color: #9aa6c1;
      flex: 1;
      text-align: center;
      padding-bottom: 10px;
      border-bottom: 2px solid #707070;
      &:hover {
        color: #fff;
        cursor: pointer;
      }
    }
    .active {
      color: #fff;
      border-color: #407aee;
    }
  }
  .video-content {
    height: calc(100% - 46px);
  }
  .show-time {
    height: calc(100% - 210px) !important;
  }
  .video-time {
    position: absolute;
    background: #fff;
    bottom: 0px;
    left: 0;
    width: 100%;
    z-index: 2;
    .date-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px;
      // color: #9aa6c1;
      cursor: pointer;
    }
    .date-content {
      padding: 16px 12px 30px;
      @include set_theme_color(background-color, left-menu-bg-color);
    }
  }
}
</style>
